import React from "react";
import { Button, Modal, Table } from "semantic-ui-react";
import TableComponent from "../../TableComponent";
import useCheckMobileScreen from "../../../hooks/useCheckMobileScreen";


interface AuditOfficesDataModalProps {
    auditOfficesDataModal: boolean;
    setAuditOfficesDataModal: React.Dispatch<React.SetStateAction<boolean>>;
    New_office_id: string;
    New_office_admin_ids: string;
    New_office_level: string;
    New_office_name: string;
    New_paper_apps_enabled: string;
    New_parent_office_id: string;
    New_updated_date: string;
    New_allowed_high_risk_processors: string;
    New_allowed_low_risk_processors: string;
    New_allowed_risk_levels: string;
    Old_office_id: string;
    Old_office_admin_ids: string;
    Old_office_level: string;
    Old_office_name: string;
    Old_paper_apps_enabled: string;
    Old_parent_office_id: string;
    Old_updated_date: string;
    Old_allowed_high_risk_processors: string;
    Old_allowed_low_risk_processors: string;
    Old_allowed_risk_levels: string;
    handleCancel: (refresh_data: boolean) => void
    newAllowedRms: any;
    oldAllowedRms: any;
    newOfficeDeactivated: string;
    oldOfficeDeactivated: string;
    newOfficeManagerIds: any;
    oldOfficeManagerIds: any;
}

const AuditOfficesDataModal = (props: AuditOfficesDataModalProps) => {

    const { auditOfficesDataModal, New_office_id,
        New_office_admin_ids,
        New_office_level,
        New_office_name,
        New_paper_apps_enabled,
        New_parent_office_id,
        New_updated_date,
        New_allowed_high_risk_processors,
        New_allowed_low_risk_processors,
        New_allowed_risk_levels,
        Old_office_id,
        Old_office_admin_ids,
        Old_office_level,
        Old_office_name,
        Old_paper_apps_enabled,
        Old_parent_office_id,
        Old_updated_date,
        Old_allowed_high_risk_processors,
        Old_allowed_low_risk_processors,
        Old_allowed_risk_levels,
        oldAllowedRms,
        handleCancel,
        newAllowedRms,
        newOfficeDeactivated,
        oldOfficeDeactivated,
        newOfficeManagerIds,
        oldOfficeManagerIds
    } = props
    const headerKeys = [
        { label: 'Field', key: 'field'},
        {label: 'After update', key: 'newV'},
        {label: 'Before update', key: 'oldV'},
    ];
    const tableMeta = [
        { field: 'Office ID', newV: New_office_id, oldV: Old_office_id },
        { field: 'Office admin IDs', newV: New_office_admin_ids, oldV: Old_office_admin_ids },
        { field: 'Office manager IDs', newV: newOfficeManagerIds, oldV: oldOfficeManagerIds},
        { field: 'Office level', newV: New_office_level, oldV: Old_office_level},
        { field: 'Office name', newV: New_office_name, oldV: Old_office_name},
        { field: 'Status', newV: newOfficeDeactivated, oldV: oldOfficeDeactivated },
        { field: 'Paper apps', newV: New_paper_apps_enabled, oldV: Old_paper_apps_enabled},
        { field: 'Parent office id', newV: New_parent_office_id, oldV: Old_parent_office_id},
        { field: 'Created Date', newV: New_updated_date, oldV: Old_updated_date},
        { field: 'High risk banks', newV: New_allowed_high_risk_processors, oldV: Old_allowed_high_risk_processors},
        { field: 'Low risk banks', newV: New_allowed_low_risk_processors, oldV: Old_allowed_low_risk_processors},
        { field: 'Risk levels', newV: New_allowed_risk_levels, oldV: Old_allowed_risk_levels},
        { field: 'RMs', newV: newAllowedRms, oldV: oldAllowedRms}
    ];

    const MobileModel = () =>(<TableComponent
        className="user-data-model-table"
        headerList={headerKeys}
        rowKeys={[]}
        tableData={tableMeta}
        hasAction={false}
        uniqueId={'objectID'}
        displayFooter={false} />);

    const isMobile = useCheckMobileScreen();
    if(isMobile) return <>
        <MobileModel/>;
        <Button color='blue' onClick={() => handleCancel(false)}>
            Close
        </Button>
    </>
    return (<>
        <Modal
            closeIcon
            centered
            open={auditOfficesDataModal}
            onClose={() => handleCancel(false)}
            size="small"
            closeOnEscape={false}
            closeOnDimmerClick={false}
        >
            <Modal.Content scrolling>
                <Modal.Description>
                    { !isMobile && (<Table textAlign="center" celled striped structured>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Fields</Table.HeaderCell>
                                <Table.HeaderCell>After Updating</Table.HeaderCell>
                                <Table.HeaderCell>Before Updating</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                        {tableMeta.map((t:any) => (<Table.Row>
                                <Table.Cell>{t.field}</Table.Cell>
                                <Table.Cell>{t.newV}</Table.Cell>
                                <Table.Cell>{t.oldV}</Table.Cell>
                            </Table.Row>))}
                            </Table.Body>
                    </Table>)}
                    {isMobile && <MobileModel/>}
                </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
                <Button color='blue' onClick={() => handleCancel(false)}>
                    Close
                </Button>
            </Modal.Actions>
        </Modal>
    </>)
}
export default AuditOfficesDataModal;
